import { useState, useEffect } from "react";
import { Outlet, Navigate, Link } from "react-router-dom";
import { useStateContext } from "../../Context/ContextProvider";
import { BsGrid3X3GapFill } from "react-icons/bs";
import catalogue from "../../image/Catalogue.png"
import malagasy from "../../image/malagasy.png"
import Footer from "../Footer/Footer";
import axios from "axios";
import AppLauncherGrid from "./AppLauncher";

export default function GuestLayout() {

  const { token, user } = useStateContext();

  //responsive
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
  const toggleMobileMenu = () => setMobileMenuOpen(!isMobileMenuOpen);

  // dropdown microservice
  const [isOpen, setOpen] = useState(false);
  const toggleDropdown = () => {
    setOpen(!isOpen);
  };

  //beta
  const [isBetaOpen, setIsBetaOpen] = useState(false);
  const toogleBeta = () => {
    setIsBetaOpen(!isBetaOpen);
  }

  //dropdown changement de langue
  // const [isLangue, setLangue] = useState(false);
  // const [language, setLanguage] = useState("fr");

  // const toggleDropdownLangue = () => {
  //   setLangue(!isLangue);
  // }
  // const handleLanguageChange = (lang) => {
  //   setLanguage(lang);
  //   setLangue(false); 
  // };

  // const flag = language === "fr" ? fr : en;
  // const label = language === "fr" ? "FR" : "EN";

  //responsive
  // Fermer les menus lors du redimensionnement
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 768) {
        setMobileMenuOpen(false);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  //app launcher
  const [menuItems, setMenuItems] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data } = await axios.get("https://catalogue.mg.formafusion.io/api/app_launcher");
        setMenuItems(data.data);
      } catch (error) {
        console.log(error)
      }
    }
    fetchData();
  }, []);

  if (token && user?.roles?.length > 0) {
    const roleId = user.roles[0].id;

    if (["1", "2", "4", "5", "6", "7"].includes(roleId)) {
      return <Navigate to="/etp/etpcatalogue" />;
    } else if (roleId === "9") {
      return <Navigate to="/cfp/catalogue" />;
    }
  }

  return (
    <>
      {/* Barre de navigation principale */}
      <div className="flex flex-col min-h-screen">
        <div className="fixed top-0 z-50 w-full bg-white/90 text-slate-700 backdrop-blur-md backdrop-saturate-150 shadow-lg h-16 px-4 md:px-6">
          <nav className="flex items-center justify-between h-full">
            {/* Logo et titre */}
            <div className="flex items-center gap-2">
              <button
                className="md:hidden mr-3 text-xl"
                onClick={toggleMobileMenu}
              >
              </button>
              <Link to="/" className="flex items-center gap-2 hover:text-slate-500 transition-colors">
                <div className="w-14">
                  <img src={catalogue} />
                </div>
                <h1 className="text-lg md:text-xl font-semibold tracking-wide">Catalogue</h1>
              </Link>


              <div
                className="cursor-pointer text-sm px-3 py-1 font-semibold bg-green-500 text-white rounded-full border border-green-600 shadow-md transition-all duration-300 hover:bg-green-600 hover:shadow-lg"
                onClick={toogleBeta}
              >
                <h1 className="text-xs tracking-wide uppercase">Beta</h1>
              </div>
              {/* ouverture beta */}
              {isBetaOpen && (
                <div className="absolute top-full mt-2 w-80 bg-white text-sm text-gray-700 p-5 rounded-xl shadow-xl border border-gray-300 z-10 dark:bg-gray-800 dark:text-gray-200 dark:border-gray-700 transition-all duration-300">

                  <h1 className="text-purple-600 dark:text-purple-400 font-semibold text-base mb-2 flex items-center gap-2">
                    🚧 <span>La plateforme est en <span className="underline">BETA ouverte</span> !</span>
                  </h1>

                  <p className="mb-4 leading-relaxed text-gray-600 dark:text-gray-300">
                    Nous travaillons activement pour l'améliorer, et vos retours sont essentiels.
                  </p>

                  <Link
                    to="https://forma-fusion.com/contact/?fbclid=IwZXh0bgNhZW0CMTEAAR4JoY_z7ESPf-9bZO8TjKIz-LxJiai36sATGVmzmvbm7VImq-4KcYAHntV8gA_aem_xukHLAMFFweTLMqxkueCrQ"
                    className="inline-block text-white bg-purple-600 hover:bg-purple-700 transition-colors duration-300 px-4 py-2 rounded-full text-center font-medium dark:bg-purple-500 dark:hover:bg-purple-600"
                    target="_blank"
                  >
                    📩 Contactez-nous ici
                  </Link>
                </div>

              )}

            </div>

            <div className="flex items-center justify-end gap-4">
              {/* Changement de langue */}
              {/* <div className="relative">
                <div
                  className="cursor-pointer flex items-center gap-1"
                  onClick={toggleDropdownLangue}
                >
                  <img src={flag} className="w-6 h-6 md:w-8 md:h-8 object-contain rounded-full" alt="Langue" />
                  <span className="hidden sm:inline">{label}</span>
                </div>

                {isLangue && (
                  <div className="absolute mt-2 w-24 bg-white rounded-xl shadow-xl p-2 z-50 text-center left-[1%]">
                    <div
                      onClick={() => handleLanguageChange("fr")}
                      className="cursor-pointer hover:bg-gray-100 rounded-lg py-1"
                    >
                      Français
                    </div>
                    <div
                      onClick={() => handleLanguageChange("en")}
                      className="cursor-pointer hover:bg-gray-100 rounded-lg py-1"
                    >
                      Anglais
                    </div>
                  </div>
                )}
              </div> */}

              <div className="w-10 h-10">
                <img src={malagasy} className="w-full"/>
              </div>

              {/* Menu (barres) */}
              <div className="relative">

                <div
                  className="p-2 rounded-full hover:bg-gray-200 transition cursor-pointer"
                  onClick={toggleDropdown}
                >
                  <BsGrid3X3GapFill className="text-xl text-gray-600 hover:text-[#A462A4]" />
                </div>

                {isOpen && (
                  
                  <div className="origin-top-right absolute right-0 mt-3 w-[493px] sm:w-110 rounded-2xl shadow-xl bg-white focus:outline-none z-30 p-5 border border-gray-100 dark:border-gray-700">

                    <AppLauncherGrid />

                  </div>

                )}

              </div>

            </div>

          </nav>

        </div>

        <main className="flex flex-col min-h-screen">

          <Outlet />

        </main>

        <Footer />

      </div>

    </>
  );
}

